import { CopyIcon, ExclamationIcon } from "../../../../../assets/svgIcons/svgIcons";
import BTC from '../../../../../assets/images/btc.png';
import SBTC from '../../../../../assets/images/sbtc.png';
import CommonButton from "../../../../../components/common/commonButton/CommonButton";
import CommonTooltip from "../../../../../components/ui/commonTooltip/CommonTooltip";
const StepThree = () => {
    return (
        <div className="stake_deposit">
            <div className="stake_deposit_to">
                <span className="stake_deposit_to_label">Deposit BTC to</span>
                <div className="address"><span>bc1qnjhzgt7uymfpga8p612rwrh7jme7gp70utlOma</span> <button><CopyIcon /></button></div>
                <p>Your stake will be shown in the staking activity section of the dashboard
                    in 5 — 10 minutes.</p>
            </div>
            <p className="unique_address">This Segwit address is unique to you. BTC sent here is mintable as SBTC to
                Ox7cO...850b3 on Ethereum only.</p>
            <div className="minimum_amt">
                <CommonTooltip
                    popoverTitle="Popover Title"
                    popoverContent="This is the popover content."
                    trigger="click"
                    placement="right"
                    btnIcon={<ExclamationIcon />}
                />
                Minimum amount 0.0002 BTC</div>
            <ul className="common_listing">
                <li><span>You are staking</span> <div><strong>1BTC</strong> <img src={BTC} alt="" className="me-0" /></div></li>
                <li><span>You will receive</span> <div><strong>1SBTC</strong> <img src={SBTC} alt="" className="me-0" /></div></li>
            </ul>
            <hr />
            <ul className="common_listing">
                <li><span>Exchange rate</span> <div><span>1 BTC = 1 SBTC</span></div></li>
                <li><span>Staking fee CD  
                    <CommonTooltip
                    popoverTitle="Popover Title"
                    popoverContent="This is the popover content."
                    trigger="click"
                    placement="right"
                    btnIcon={<ExclamationIcon />}
                />
                </span> <div><span>$0.00</span></div></li>
                <li><span>Incentives O  
                    <CommonTooltip
                    popoverTitle="Popover Title"
                    popoverContent="This is the popover content."
                    trigger="click"
                    placement="right"
                    btnIcon={<ExclamationIcon />}
                />
                </span> <div><span>Babylon incentives</span></div></li>
                <li><span>Confirmation time  
                    <CommonTooltip
                    popoverTitle="Popover Title"
                    popoverContent="This is the popover content."
                    trigger="click"
                    placement="right"
                    btnIcon={<ExclamationIcon />}
                />
                </span> <div><span>60 minutes (6 blocks)</span></div></li>
            </ul>
            <CommonButton title="Waiting for your deposit" isLoading fluid disabled />
        </div>
    )
}
export default StepThree